import { LoadState } from "../../constants/enums";

export interface INoticesState {
  list: INotices[];
  totalRecords: number;
  loading: LoadState;
}

export interface INotices{
  notice_and_edocs_id: number;
  record_type: string;
  notice_and_edoc_code: string;
  customer_policy_id: string | null;
  customer_id: string | null;
  customer_name: string | null;
  customer_email: string | null;
  insurer_id: string | null;
  insurance_company: string | null;
  policy_type: string | null;
  notice_code: string | null;
  notice_type: string | null;
  description: string | null;
  policy_number: string | null;
  line_of_business: string | null;
  producer_code: string | null;
  csr_code: string | null;
  branch_code: string | null;
  status_other: string | null;
  action_taken: string | null;
  due_time: string | null;
  due_date: string | null;
  message_type: string | null;
  email: string | null;
  mobile_number: string | null;
  assigned_to_id: number;
  message_guid: string | null;
  csio_edoc_code: string | null;
  type: string | null;
  business_purpose_type: string | null;
  contract_term_effective_date: string | null;
  contract_term_expiry_date: string | null;
  attachment: string | null;
  address_of_insured: string | null;
  payment_plan: string | null;
  day_of_month_due: string | null;
  minimum_due_amount: string | null;
  total_amount_due: string | null;
  method_of_payment: string | null;
  previous_billed_amount: string | null;
  total_paid_amount: string | null;
  last_payment_amount: string | null;
  last_payment_date: string | null;
  next_bill_amount: string | null;
  next_bill_date: string | null;
  document_copy_type: string | null;
  billing_activity_type: string | null;
  billing_activity_description: string | null;
  payment_due_date: string | null;
  amount_due: string | null;
  claim_number: string | null;
  loss_date: string | null;
  cause_of_loss: string | null;
  location_of_loss: string | null;
  claim_status: string | null;
  adjuster_name: string | null;
  reported_date: string | null;
  risk_auto_property: string | null;
  type_vehicle: string | null;
  property: string | null;
  insured_address: string | null;
  adjuster_telephone_number: string | null;
  adjuster_email: string | null;
  adjuster_address: string | null;
  fault: string | null;
  total_incurred: string | null;
  losses_paid: string | null;
  expenses_paid: string | null;
  recovery: string | null;
  close_date: string | null;
  fault_determination: string | null;
  rental_approved_indicator: string | null;
  rental_start_date: string | null;
  rental_end_date: string | null;
  rental_amount: string | null;
  fault_pct: string | null;
  claimant: string | null;
  payment_issued: string | null;
  payment_date: string | null;
  payment_sent_to: string | null;
  payment_method: string | null;
  payment_amount: string | null;
  total_loss: string | null;
  remarks: string | null;
  producer_one_id: string | null;
  financed: string | null;
  financed_by: string | null;
  action_needed: string | null;
  action_status: string | null;
  status: string;
  create_ts: string | null;
}
// export interface INotice {
//   incremental_number: number | null;
//   notice_code: string | null;
//   notice_type: string | null;
//   description: string | null;
//   customer_id: number | null;
//   customer_name: string | null;
//   policy_number: string | null;
//   line_of_business: string | null;
//   producer_code: string | null;
//   csr_code: string | null;
//   branch_code: string | null;
//   status_other: string | null;
//   action_taken: string | null;
//   file_upload: string | null;
//   notes: string | null;
//   assigned_to_id: number | null;
//   status: string;
//   due_date: string | null;
//   create_ts: string | null;
//   due_time: string | null;
//   insurer_id: string | null;
//   policy_type: string | null;
//   message_type: string | null;
//   mobile_number: string | null;
//   email: string | null;
// }

export const initialNotice: INotices = {
  notice_and_edocs_id: 0,
  record_type: "",
  notice_and_edoc_code: "",
  customer_policy_id: null,
  customer_id: null,
  customer_name: null,
  customer_email: null,
  insurer_id: null,
  policy_type: null,
  notice_code: null,
  notice_type: null,
  description: null,
  policy_number: null,
  line_of_business: null,
  producer_code: null,
  csr_code: null,
  branch_code: null,
  status_other: null,
  action_taken: null,
  due_time: null,
  due_date: null,
  message_type: null,
  email: null,
  mobile_number: null,
  assigned_to_id: 0,
  message_guid: null,
  csio_edoc_code: null,
  type: null,
  business_purpose_type: null,
  insurance_company: null,
  contract_term_effective_date: null,
  contract_term_expiry_date: null,
  attachment: null,
  address_of_insured: null,
  payment_plan: null,
  day_of_month_due: null,
  minimum_due_amount: null,
  total_amount_due: null,
  method_of_payment: null,
  previous_billed_amount: null,
  total_paid_amount: null,
  last_payment_amount: null,
  last_payment_date: null,
  next_bill_amount: null,
  next_bill_date: null,
  document_copy_type: null,
  billing_activity_type: null,
  billing_activity_description: null,
  payment_due_date: null,
  amount_due: null,
  claim_number: null,
  loss_date: null,
  cause_of_loss: null,
  location_of_loss: null,
  claim_status: null,
  adjuster_name: null,
  reported_date: null,
  risk_auto_property: null,
  type_vehicle: null,
  property: null,
  insured_address: null,
  adjuster_telephone_number: null,
  adjuster_email: null,
  adjuster_address: null,
  fault: null,
  total_incurred: null,
  losses_paid: null,
  expenses_paid: null,
  recovery: null,
  close_date: null,
  fault_determination: null,
  rental_approved_indicator: null,
  rental_start_date: null,
  rental_end_date: null,
  rental_amount: null,
  fault_pct: null,
  claimant: null,
  payment_issued: null,
  payment_date: null,
  payment_sent_to: null,
  payment_method: null,
  payment_amount: null,
  total_loss: null,
  remarks: null,
  producer_one_id: null,
  status: "Open",
  financed: null,
  financed_by: null,
  action_needed: null,
  action_status: null,
  create_ts: null
};

// export const initialManageNotice: INotice = {
//   incremental_number: null,
//   notice_code: null,
//   notice_type: null,
//   description: null,
//   customer_id: null,
//   customer_name: null,
//   policy_number: null,
//   line_of_business: null,
//   producer_code: null,
//   csr_code: null,
//   branch_code: null,
//   status_other: null,
//   action_taken: null,
//   file_upload: null,
//   notes: null,
//   assigned_to_id: null,
//   status: "",
//   due_date: null,
//   create_ts: null,
//   due_time: null,
//   insurer_id: null,
//   policy_type: null,
//   message_type: null,
//   mobile_number: null,
//   email: null
// }

export const initialNoticesState: INoticesState = {
  list: [],
  totalRecords: 0,
  loading: LoadState.NotLoaded,
};


export interface ICustomerAllPolicyDetail {
  policy_status: string;
  customer_policy_id: string;
  customer_id: string;
  customer_name: string;
  customer_code: string;
  policy_number: string;
  policy_sub_type: string;
  line_of_business: string;
  producer_one_code: string;
  producer_one: string;
  producer_two: string;
  producer_two_code: string;
  producer_three: string;
  producer_three_code: string;
  insurer: string;
  marketer_code: string;
  marketer: string;
  effective_date: string;
  expiry_date: string;
  branch_code: string;
  insert_ts: string;
}
